import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import get from 'lodash.get';

import { AppState } from 'services/types';
import { WorksheetEntitySummaryIndex } from 'services/worksheet/types';
import { selectSprayWorksheetEntitySummaries } from '../../../../selectors';
import { OwnProps } from './index';

const selectEntitySummaryIndex = (
    state: AppState,
    props: OwnProps
): WorksheetEntitySummaryIndex => props.entitySummaryIndex;

const selectOrchard = createDeepEqualSelector(
    selectSprayWorksheetEntitySummaries,
    selectEntitySummaryIndex,
    (entitySummaries, index) => get(entitySummaries, [index, 'entity', 'name'])
);

const makeSelectOrchard = (): typeof selectOrchard => selectOrchard;

export { selectEntitySummaryIndex, makeSelectOrchard };
